// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FJrp","question":"styles_question__2Uy_-","description":"styles_description__2pznC"};